// extracted by mini-css-extract-plugin
export default {"card":"simple-fun_card__2Q8Ew","inner":"simple-fun_inner__dxIUo","slideHeading":"simple-fun_slideHeading__Pv0ki","slideDescr":"simple-fun_slideDescr__v5xKO"};